import { Link } from "react-router-dom";
import { contactInfo } from "@/mocks/site";
import { heroHighlights } from "@/mocks/home";
import { getServiceDetail } from "@/mocks/services";
import { areaAnchorId } from "@/utils/areaSlug";
import { HERO_IMAGES } from "@/config/heroImages";

const FEATURED_LOCALITIES = ["Nagarabhavi", "Jayanagar", "HSR Layout", "Whitefield", "Marathahalli", "Yelahanka"];

export default function Hero() {
  const heroAreas = (getServiceDetail("local-shifting")?.areas ?? []).filter((area) =>
    FEATURED_LOCALITIES.includes(area.name),
  );

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGES.home}
          alt="Lahari Packers and Movers, Bangalore home shifting service"
          title="Lahari Packers and Movers Bangalore"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/90 via-foreground-950/75 to-accent-950/80" />
      </div>

      <div className="relative mx-auto max-w-screen-2xl px-4 pb-16 pt-32 md:px-6 md:pb-20 md:pt-40">
        <div className="max-w-3xl">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/20 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-primary-200">
              <i className="ri-award-fill" /> Trusted Since 2009
            </span>
            <h1 className="mt-5 font-heading text-3xl font-extrabold leading-tight text-background-50 md:text-5xl">
              Lahari Packers and Movers, Bangalore
            </h1>
            <p className="mt-4 font-heading text-lg font-semibold text-primary-200 md:text-2xl">
              #1 Home Shifting Services in Bangalore
            </p>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
              Pioneers in providing home shifting services near Nagarabhavi since 2009. We offer flexible moving
              services in Bangalore at the best price with no hidden costs. Safe and trusted shifting service is always
              guaranteed. Write to us for a free quote on Packing &amp; Moving and Relocation.
            </p>

            <div className="mt-6 flex flex-wrap gap-4">
              {heroHighlights.map((h) => (
                <span key={h.label} className="flex items-center gap-2 text-sm text-background-100">
                  <i className={`${h.icon} text-lg text-primary-300`} />
                  {h.label}
                </span>
              ))}
            </div>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href={contactInfo.phoneHref}
                data-cta="Call"
                data-cta-location="hero"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-phone-fill text-lg" /> Call {contactInfo.phone}
              </a>
              <Link
                to="/request-a-quote"
                data-cta="Get a Free Quote"
                data-cta-location="hero"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-white/10"
              >
                <i className="ri-file-text-line text-lg" /> Get a Free Quote
              </Link>
            </div>

            {heroAreas.length > 0 && (
              <div className="mt-8">
                <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-200">
                  <i className="ri-map-pin-2-line text-base" aria-hidden="true" /> Local shifting in
                </p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {heroAreas.map((area) => (
                    <Link
                      key={area.name}
                      to={`/services/local-shifting#${areaAnchorId(area.name)}`}
                      className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-background-100/30 bg-white/10 px-3 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm transition-colors hover:border-primary-300 hover:bg-primary-500/25"
                    >
                      <i className="ri-map-pin-2-line text-primary-200" aria-hidden="true" />
                      {area.name}
                    </Link>
                  ))}
                  <Link
                    to="/services/local-shifting"
                    className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1.5 text-xs font-semibold text-background-50 transition-colors hover:bg-accent-600"
                  >
                    View all areas <i className="ri-arrow-right-line" aria-hidden="true" />
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}